import React from 'react';

import DetailsListComponent from '../components/app/Details/DetailsList';

const DetailsList = (props) => {
  return (
    <DetailsListComponent {...props} />
  );
};

export default DetailsList;
